import React, { useState, useCallback, useEffect, useRef, useMemo } from "react";
import { connect } from "react-redux";
import FormField from '../../../../../../dynamicFormBuilder/FormField'
import { AdditionalLayout } from './Layout';
import { DisableEnableControls } from "../../../../../../common/Utils";
import { ApplyMethod, YesNo } from "../../../../../../enum/Enum";

function AdditionalTab(props) {
    var currentUser = props.oidc.user;
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
    const formRefs = useRef({});
    const handleAdditionalFormLoad = useCallback(() => {
        loadLookupFromStaticData(formRefs, "Taxableflag", [{ id: 'Y', name: 'Yes' }, { id: 'N', name: 'No' }]);
        loadLookupFromStaticData(formRefs, "Pickstatus", [{ id: 'Y', name: 'Yes' }, { id: 'N', name: 'No' }]);
        loadLookupFromStaticData(formRefs, "Artradediscountflag", [{ id: 'Y', name: 'Yes' }, { id: 'N', name: 'No' }]);
        loadLookupFromStaticData(formRefs, "Artermsdiscountflag", [{ id: 'Y', name: 'Yes' }, { id: 'N', name: 'No' }]);
        DisableEnableFields();
    }, []);
    useEffect(() => {
       DisableEnableFields();
    }, [props.formFields]);
    const handleFieldChange = useCallback((name, value, e) => {
    }, []);
    const handleSelectionChange = useCallback((name, value, e) => {

    }, []);
    const loadLookupFromStaticData = (formRefs, name, dataSource) => {
        if (formRefs.current[name]) {
            formRefs.current[name].instance().option('dataSource', dataSource);
            formRefs.current[name].instance().option('valueExpr', 'id');
            formRefs.current[name].instance().option('displayExpr', 'name');
            if (props.formFields[name])
                formRefs.current[name].instance().option('value', props.formFields[name]);
        }
    };
    const DisableEnableFields = () => {
        if (props.formFields) {
            let isDiscountControlsEnabled = true;
            if (props.formFields?.ApplyMethod === ApplyMethod.ApplyMethodSpecifyPrice) {
                isDiscountControlsEnabled = false;
            }
            else if (props?.ProfileIncludeDiscountInUnitPrice === YesNo.Yes) {
                isDiscountControlsEnabled = false;
            }
            DisableEnableControls("Discountpercent", !isDiscountControlsEnabled, formRefs);
            DisableEnableControls("DiscountedPrice", !isDiscountControlsEnabled, formRefs);
        }
    };
    return (
        <div style={{ height: '100%', overflow: 'auto' }}>
            <FormField
                currrentUser={currentUser}
                layoutId='9C28D4C1-93DF-4762-81D1-02C453779EFC'
                layoutName='OMSalesOrderDataEntryAdditionalForm'
                defaultFormSchema={AdditionalLayout}
                formFields={props.formFields}
                setformFields={props.setformFields}
                handleFieldValueChange={handleFieldChange}
                DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                formRefs={formRefs}
                onFormLoad={handleAdditionalFormLoad}
                handleSelectedItemChange={handleSelectionChange}
            />

        </div>
    );
}
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(AdditionalTab);
